// FR · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "Nouveautés de WA Checkin",
  "kicker": "Nouveautés",
  "stepOf": "Étape {n} sur {total}",
  "close": "Fermer",
  "dontShow": "Ne plus afficher",
  "prev": "Précédent",
  "next": "Suivant",
  "done": "Compris",
  "steps": {
    "icons": {
      "title": "Des icônes sur vos réservations",
      "text": "Chaque réservation du calendrier et de la liste affiche désormais de petites icônes : demandes à la Réception IA, appels, notes et montant restant à encaisser. Survolez-les pour voir le détail sans ouvrir la réservation.",
      "cta": ""
    },
    "early": {
      "title": "Faites payer l'arrivée anticipée",
      "text": "L'early check-in peut désormais être payant. L'agent IA demande l'heure d'arrivée, calcule le prix et envoie le lien de paiement. Une fois payé, il est confirmé automatiquement.",
      "cta": "Configurer dans Agent IA"
    },
    "reception": {
      "title": "Réception IA",
      "text": "Tout ce que vos clients demandent à l'agent (arriver plus tôt, partir plus tard, nuits en plus, factures, messages d'appel) arrive dans une seule boîte. Acceptez, refusez ou priorisez en un clic et voyez le montant de ce qui est facturé.",
      "cta": "Ouvrir la Réception IA"
    },
    "translate": {
      "title": "Traduction en temps réel",
      "text": "Dans le chat de chaque réservation et dans la boîte de réception, activez la traduction : ce qu'écrit le client vous arrive dans votre langue et, en appuyant sur Entrée, vous voyez d'abord votre message traduit dans la sienne avant de l'envoyer.",
      "cta": "Aller aux messages"
    },
    "voice": {
      "title": "Appels avec l'agent vocal",
      "text": "Activez l'accueil téléphonique : l'agent IA répond aux appels dans la langue de l'appelant, répond aux questions, envoie le lien de réservation et vous laisse un résumé de chaque appel.",
      "cta": "Activer les appels"
    }
  },
  "demo": {
    "iconsTipTitle": "Réception IA",
    "iconsTipEarly": "Early check-in",
    "iconsTipPending": "Reste à payer :",
    "paid": "Payée",
    "earlyGuest": "Pouvons-nous arriver à 11h00 ?",
    "earlyAgent": "Oui ! L'arrivée à 11h00 coûte 30 €. Vous pouvez payer ici :",
    "earlyPaid": "Payée · confirmée",
    "rx": {
      "early": "Early check-in",
      "late": "Late checkout",
      "extend": "Prolonger"
    },
    "pending": "En attente",
    "confirmed": "Confirmée",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "À quelle heure pouvons-nous récupérer les clés ?",
    "trMine": "À partir de 15h00, nous vous attendons",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Résumé de l'appel",
    "voiceSummary": "A demandé le parking et réservé 2 nuits. Lien de réservation envoyé par WhatsApp."
  }
};
